import { Component, inject, OnDestroy, OnInit, output, OutputEmitterRef } from '@angular/core';
import { AdminService } from '@customer/admin';
import { SpinnerService, StorageService } from '@core/services';
import { SessionAuth } from '@legacy-models/auth/user';
import posthog from 'posthog-js';
import { Subscription } from 'rxjs';

@Component({
  selector: 'oke-acknowledgment',
  templateUrl: './acknowledgment.html',
  styleUrl: './acknowledgment.scss',
  imports: []
})
export class Acknowledgment implements OnDestroy, OnInit {
  private readonly _adminSvc: AdminService = inject(AdminService);
  private _user: SessionAuth | null = null;
  readonly adminAcknowledgmentSubmitted: OutputEmitterRef<void> = output<void>();
  protected hasAgreed = false;
  private readonly _subscriptions: Subscription[] = [];
  readonly spinnerSvc: SpinnerService = inject(SpinnerService);
  readonly storageSvc: StorageService = inject(StorageService);

  ngOnDestroy(): void {
    this._subscriptions?.forEach(subscription => subscription?.unsubscribe);
  }

  ngOnInit(): void {
    this._subscriptions.push(
      this.storageSvc.currentUser$.subscribe(currUser => {
        if (currUser) {
          this._user = currUser;
        }
      })
    );
  }

  toggleAcceptAccountAdminAcknowledgement(event: MouseEvent): void {
    const agreedCheckBox = event.currentTarget as HTMLInputElement;
    const agreedCheckBoxLabel = document.getElementById('agreed-check');
    if (agreedCheckBox.checked) {
      agreedCheckBoxLabel?.classList.remove('unagreed-check');
      this.hasAgreed = true;
    } else {
      agreedCheckBoxLabel?.classList.add('unagreed-check');
      this.hasAgreed = false;
    }
  }

  submitAccoutAdminAcknowledgement(): void {
    //make a call to admin service to submit acknowledgement on behalf of the Account and Administrator
    this.spinnerSvc.showSpinnerButton();
    posthog.capture('admin:account_acknowledgment_submit');
    this._adminSvc.putAccountAdminAcknowledgment().then(() => {
      if (!this._user?.Contact) {
        return;
      }
      this._user.Contact.IsAdminAgreementAcknowledged = true;
      this.adminAcknowledgmentSubmitted.emit();
      this.storageSvc.setCurrentUser(this._user);
    });
  }
}
